{
  "zh-TW": {
    "directUpload": {
      "title": "上傳",
      "chooseFiles": "選擇檔案",
      "dropzone": {
        "textMultiple": "將檔案拖拽到這裡上傳",
        "text": "將檔案拖拽到這裡上傳",
        "or": "或",
        "browse": "瀏覽"
      },
      "previewImage": {
        "remove": "移除"
      },
      "actions": {
        "upload": "上傳",
        "close": "關閉"
      }
    }
  }
}
